// extracted by mini-css-extract-plugin
export default {"card":"K3-z"};